module.exports = "<div class=\"loader\">Loading...</div>"